// GENERATED by scripts/build-icons.mjs from icons/upload.svg — do not edit.
// Lucide (ISC); Feather-derived icons additionally MIT. See LICENSE-lucide.
import { createIcon } from '../createIcon'

export const Upload = createIcon('upload', [
  ['path', { d: "M12 3v12" }],
  ['path', { d: "m17 8-5-5-5 5" }],
  ['path', { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }],
])
